import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { AbstractFeatureGitService, getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import {
  VisualizationDashboardSettingsGitModel,
  VisualizationDashboardStoreModel,
} from './visualization-dashboard.model';

@Injectable({ providedIn: 'root' })
export class VisualizationDashboardGitService extends AbstractFeatureGitService<
  VisualizationDashboardStoreModel,
  Y42GitFolders.VisualizationDashboard
> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
  ) {
    super({
      gitQuery,
      git,
      name: 'Visualization-Git',
      basePath: getY42GitPath(Y42GitFolders.VisualizationDashboard),
      errorHandlerService,
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: VisualizationDashboardSettingsGitModel,
        },
      },
      hydrationDefinition: {
        1: {
          modelType: 'folder',
          childType: 'folder',
        },
        2: {
          modelType: 'folder',
          childType: 'file',
          childFolder: 'canvas',
        },
        3: {
          modelType: 'file',
        },
      },
    });
  }
}
